// extracted by mini-css-extract-plugin
export default {"not_alone":"NotAlone_not_alone__ZW2JO","header":"NotAlone_header__h4DyI","desc":"NotAlone_desc__KDy7F","next_page_navigation":"NotAlone_next_page_navigation__3ZeR0"};